import React from 'react';
import TextField from "@material-ui/core/TextField";
import HeaderButton from "../../components/utils/button/HeaderButton";
import SubmitButton from '../../components/utils/button/SubmitButton';
import Buttons from '../../components/utils/buttonsContainer/Buttons';
import { useFormik } from 'formik';
// assets
import borrar from "../../assets/icons/borrar.svg";
import reload from "../../assets/icons/actualizar.svg";
import lupa from "../../assets/icons/lupa.png"
// recoil
import { useRecoilValue } from 'recoil';
import { rowSelected } from '../../recoilState/GlobalState';
import { FiltrosStyles } from '../Filtros.styles';
import { FormikSelectInput, FormikTextInput } from '../../components/utils/inputs/FormikInputs';

export default function ApellidoYDNISelect(props) {
    const { status } = useRecoilValue(rowSelected);
    const { filtros, setFiltros, handleClick, updateList, cargando, registros } = props;

    const formik = useFormik({
        initialValues: filtros,
        onSubmit: (values) => setFiltros(values)
    });

    const data = { registro: { label: 'Registro' }, apellido: { label: 'Apellido' }, documento: { label: 'Documento' } };
    const classes = FiltrosStyles();

    return (
        <form className={classes.root} onSubmit={formik.handleSubmit}>
            <div className={classes.filtros}>
                <FormikSelectInput
                    data={data}
                    name="registro"
                    formik={formik}
                    disabled={cargando}
                    options={[{ registroId: 'todos', registroNombre: 'Todos' }, ...registros]}
                    optionKey="registroId"
                    optionValue="registroId"
                    optionName="registroNombre"
                    className={classes.input}
                />
                <div className={classes.inputContainer}>
                    <FormikTextInput
                        data={data}
                        name="apellido"
                        formik={formik}
                        disabled={cargando}
                        className={classes.input}
                    />
                    {formik.values.apellido !== '' &&
                        <img
                            alt="borrar"
                            src={borrar}
                            onClick={() => formik.setFieldValue('apellido', '')}
                            className={classes.iconoBorrar}
                        />
                    }
                </div>
                <div className={classes.inputContainer}>
                    <FormikTextInput
                        data={data}
                        name="documento"
                        formik={formik}
                        disabled={cargando}
                        className={classes.input}
                    />
                    {formik.values.documento !== '' &&
                        <img
                            alt="borrar"
                            src={borrar}
                            onClick={() => formik.setFieldValue('documento', '')}
                            className={classes.iconoBorrar}
                        />
                    }
                </div>
                <div className={classes.marginNormal}>
                    <SubmitButton texto="Buscar" />
                </div>
            </div>
            <Buttons>
                {status ?
                    <HeaderButton
                        text={'Ver status'}
                        icon={lupa}
                        data={{ action: '', procede: '' }}
                        handleClick={handleClick}
                    />
                    :
                    <HeaderButton
                        text={'Actualizar pagina'}
                        icon={reload}
                        updateList={updateList}
                    />
                }
            </Buttons>
        </form>
    )
};